import { API, removeBlankAttributes } from "@project/common"
import { PAGE_SIZE } from "../constants"
import dayjs from "dayjs"
interface IMinutesQuery {
  page?: string | number
  pageSize?: string
  facility?: any
  facilityIds?: any
  user_id?: string | number
  start_date?: string | number
  end_date?: string | number
  created?: boolean
  saved_as_draft?: boolean
  create_status?: string
}
export const fetchMinutesOfMeetingOfPic = ({ queryKey }): Promise<Response> => {
  const params = {} as IMinutesQuery
  params.page = queryKey[1]
  params.pageSize = queryKey[2] || PAGE_SIZE
  params.facilityIds = queryKey[3].facility || []
  params.user_id = queryKey[3].user_id || ""
  params.start_date = queryKey[3].start_date || ""
  params.end_date = queryKey[3].end_date || ""

  if (queryKey[3].created && !queryKey[3].saved_as_draft) {
    params.create_status = "created"
  } else if (!queryKey[3].created && queryKey[3].saved_as_draft) {
    params.create_status = "draft"
  }

  const query = removeBlankAttributes(params)
  return API.get(`/minutes`, {
    params: query,
  })
}
export const createMinutesOfMeetingOfPic = async (values): Promise<any> => {
  delete values.absent_facility
  delete values.conference_participation_facilities
  delete values.creator_id
  delete values.conference
  return API.post(`/minutes`, values)
}
export const getOneMinutesOfMeetingOfPic = async (id: number) => {
  return API.get(`/minutes/${id}`)
}

export const updateMinutesOfMeetingOfPic = async (values) => {
  delete values.absent_facility
  delete values.conference_participation_facilities
  delete values.creator_id
  delete values.conference
  const id = values.id
  delete values.id
  return API.put(`/minutes/${id}`, values)
}
export const getAllUser = async ({
  ...args
}: {
  page: number
  pageSize: string
  service_used_by_user?: number
}) => {
  const params = removeBlankAttributes(args)
  return API.get(`/user`, { params })
}

export const getActiveUser = async (id) => {
  return API.get(`/user/${id}`)
}
export const getFacility = async () => {
  return API.get(`/facilities`)
}

export const getMinutesNumberOfCreated = (id: string) => {
  return API.get(`/minutes/no_of_created/${id}`)
}

export const getCreatorAndConferenceParticipants = (
  values: any,
): Promise<any> => {
  if (Number(values.queryKey[1]) > 1) {
    const date = dayjs(
      dayjs(values.queryKey[2])?.isValid() ? values.queryKey[2] : "",
    ).format("YYYY-MM-DD")
    return API.get(
      `/instructors?facility=${values.queryKey[1]}&page=1&pageSize=Infinity&date_staff_is_active=${date}`,
    )
  }
}

export const deleteMinutes = (id) => {
  return API.delete(`/minutes/${id}`)
}
